// extracted by mini-css-extract-plugin
module.exports = {"task-list-item":"task-list-item-7c1d412faddced6f8627fe3c01078455"};